import { useState } from "react";

import { formatCurrentPrice, isRecentlyUpdated } from "./currentPriceUtils";

/**
 * Read-only "Current Price" block for the Instance Details left column. Shows
 * the instance's latest sale value formatted as `USD 250,000`, a copy button,
 * and a "Recently Updated" tag when the price changed in the last 10 days.
 *
 * Deliberately not a Formik control — the price isn't editable on this screen.
 */
const CurrentPrice = ({ value }) => {
  const [copied, setCopied] = useState(false);

  const priceText = formatCurrentPrice(value);
  const recentlyUpdated = isRecentlyUpdated(value?.date);

  const handleCopy = async () => {
    if (!priceText) return;
    try {
      await navigator.clipboard.writeText(priceText);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // Clipboard unavailable / blocked — leave the button state unchanged.
    }
  };

  return (
    <div>
      <div className="mb-1 flex items-center gap-2">
        <span className="text-sm font-medium text-gray-700">Current Price</span>
        {recentlyUpdated ? (
          <span className="rounded-full bg-[#0047FF] px-2 py-0.5 text-xs tracking-wider text-white">
            Recently Updated
          </span>
        ) : null}
      </div>
      <div className="flex items-center gap-2">
        <span className="text-base font-semibold">{priceText || "—"}</span>
        {priceText ? (
          <button
            type="button"
            onClick={handleCopy}
            title="Copy price"
            className="rounded border border-gray-300 bg-white px-2 py-1 text-xs font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            {copied ? "Copied" : "Copy"}
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default CurrentPrice;
